import type { ReactNode } from "react";
import estilos from "./Filtros.module.css";

export interface OpcionFiltro<K extends string> {
  readonly clave: K;
  readonly texto: string;
  readonly cuenta?: number;
}

/** Grupo de filtros excluyentes; cada uno es un botón con aria-pressed y su cuenta. */
export function GrupoFiltros<K extends string>({
  etiqueta,
  opciones,
  activo,
  alElegir,
  rapido = false,
  children,
}: {
  readonly etiqueta: string;
  readonly opciones: readonly OpcionFiltro<K>[];
  readonly activo: K;
  readonly alElegir: (clave: K) => void;
  readonly rapido?: boolean;
  readonly children?: ReactNode;
}) {
  return (
    <div className={estilos.grupo} role="group" aria-label={etiqueta}>
      {opciones.map((o) => (
        <button
          key={o.clave}
          type="button"
          className={[estilos.filtro, rapido && estilos.rapido].filter(Boolean).join(" ")}
          aria-pressed={o.clave === activo}
          onClick={() => {
            alElegir(o.clave);
          }}
        >
          {o.texto}
          {o.cuenta !== undefined && ` ${o.cuenta}`}
        </button>
      ))}
      {children}
    </div>
  );
}

/** Interruptor de vista («Por aviso» / «Por persona»). */
export function SelectorVista<K extends string>({
  etiqueta,
  opciones,
  activo,
  alElegir,
}: {
  readonly etiqueta: string;
  readonly opciones: readonly { readonly clave: K; readonly texto: string }[];
  readonly activo: K;
  readonly alElegir: (clave: K) => void;
}) {
  return (
    <div className={estilos.vista} role="group" aria-label={etiqueta}>
      {opciones.map((o) => (
        <button
          key={o.clave}
          type="button"
          className={estilos.opcion}
          aria-pressed={o.clave === activo}
          onClick={() => {
            alElegir(o.clave);
          }}
        >
          {o.texto}
        </button>
      ))}
    </div>
  );
}
